<template>
    <div class='comButton' @click="btnClick">
        {{butTxt}}
    </div>
</template>

<script>
    export default {
        props:{
            butTxt:{
                type:String,
                default(){
                    return ""
                }
            }
        },
        methods:{
            btnClick(){
                this.$emit('btnClick')
            }
        }
    }
</script>
<style scoped>
.comButton{
    width:278px;
    height: 42px;
    color:#fff;
    background:var(--color-main);
    text-align: center;
    line-height: 42px;
    border-radius: 61px;
    margin:0 auto;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow:ellipsis;
    padding:0 10px;
    box-sizing: border-box;
}
@media screen and (max-width: 768px){
    .comButton{
        width:4rem;
        height: 0.6rem;
        line-height: 0.6rem;
        border-radius: 0.35rem;
        font-size:0.24rem;
        padding:0 0.1rem;
    }
}
</style>